import _ from "lodash";

export const CfsRequestByDroOpts = () => {

    const CFS_BY_CUSTOMER_KEY = "C";
    const CFS_BY_TERMINAL_KEY = "T";
    const CFS_BY_CUSTOMER_VALUE = "CFS by Customer";
    const CFS_BY_TERMINAL_VALUE = "CFS by Terminal";

    const CFS_BY_CUSTOMER = { [CFS_BY_CUSTOMER_KEY]: CFS_BY_CUSTOMER_VALUE };
    const CFS_BY_TERMINAL = { [CFS_BY_TERMINAL_KEY]: CFS_BY_TERMINAL_VALUE };


    const getCfsRequestByModel = () => {
        let items: { [key: string]: string } = {};
        items = {
            ...CFS_BY_CUSTOMER,
            ...CFS_BY_TERMINAL,
        };

        return [
            ...(_.orderBy(_.map(
                _.toPairs(items), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [], "dropdownLabel"))
        ];

    }

    const getToValueByKey = (key: string) => {
        return getCfsRequestByModel()?.find(item => item.tagLabel === key)?.value ?? "";
    }

    const getToKeyByValue = (value: string) => {
        return getCfsRequestByModel()?.find(item => item.value === value)?.tagLabel ?? "";
    }

    return {
        getCfsRequestByModel,
        getToValueByKey,
        getToKeyByValue
    }
}